module.exports = __webpack_public_path__ + "img/交通.9d8a3bf3.gif";